import { FuseLoadable } from '@fuse';

export const UserSettingsPageConfig = { routes: [{ path: '/user-settings', component: FuseLoadable({ loader: () => import('./user/UserSettings') }) }] };
export const NotificationsSettingsPageConfig = { routes: [{ path: '/notifications-settings/:user_id?', component: FuseLoadable({ loader: () => import('./notifications') }) }] };
export const ManageNotificationPageConfig = { routes: [{ path: '/add-notification/:user_id?', component: FuseLoadable({ loader: () => import('./notifications/NewNotificationDialog') }) }] };

export default [UserSettingsPageConfig, NotificationsSettingsPageConfig, ManageNotificationPageConfig];
